import { cn } from "@/lib/utils";

interface FormSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
  width?: string;
}

export function FormSection({
  title,
  description,
  children,
  className,
  width = "w-full",
}: FormSectionProps) {
  return (
    <div
      className={cn(
        "bg-[rgba(255,255,255,0.6)] flex flex-col gap-5 items-start overflow-hidden p-4 rounded-[24px]",
        width,
        className
      )}
    >
      <div className={cn("flex flex-col gap-1.5 items-start")}>
        <h4 className="text-b1-mid text-[var(--color-black-10)] whitespace-pre">
          {title}
        </h4>
        {description ? (
          <p
            style={{ fontSize: "14px" }}
            className={cn("text-b3 text-[var(--color-black-6)] -mt-1")}
          >
            {description}
          </p>
        ) : null}
      </div>

      <div
        className={cn("flex flex-col gap-2 items-stretch pb-2 pt-0  w-full")}
      >
        {children}
      </div>
    </div>
  );
}

export default FormSection;
